import { Plane } from 'lucide-react';
import type { TripCandidate } from '../domain/models';
import { ConfidenceBadge } from './ConfidenceBadge';

export function TripCard({ trip }: { trip: TripCandidate }) {
  return (
    <article className="surface trip-card">
      <header>
        <div>
          <h3>{trip.title}</h3>
          <p className="section-note">
            {trip.startDate} - {trip.endDate} / 総移動距離 {trip.totalDistanceKm.toFixed(1)} km
          </p>
        </div>
        <ConfidenceBadge confidence={trip.confidence} />
      </header>
      <div className="button-row">
        <span className="badge medium">
          <Plane size={13} aria-hidden="true" />
          最大 {trip.homeDistanceKmMax.toFixed(0)} km
        </span>
        {trip.mainAreas.map((area) => (
          <span className="badge good" key={`${trip.id}_${area.label}`}>
            {area.label}
          </span>
        ))}
      </div>
      <ul>
        {trip.reason.map((reason) => (
          <li key={reason}>{reason}</li>
        ))}
      </ul>
    </article>
  );
}
